import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@org/ui';
import { useTranslation } from 'react-i18next';
import { PendingRequestsPanel } from './pending-requests-panel';

type PendingRequestsDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

// Every student's pending access request in one place, opened from the
// Products page header. Approving reuses the grant end-date choices.
export function PendingRequestsDialog({ open, onOpenChange }: PendingRequestsDialogProps) {
  const { t } = useTranslation('admin');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t('pendingRequests.dialog.title')}</DialogTitle>
          <DialogDescription>{t('pendingRequests.dialog.description')}</DialogDescription>
        </DialogHeader>
        <div className="mt-2">{open ? <PendingRequestsPanel /> : null}</div>
        <DialogFooter className="mt-6">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('journeyAccess.dialog.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
